import {
  Alert,
  Autocomplete,
  Button,
  createFilterOptions,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Pagination,
  Snackbar,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import CardsStatusTicketComponet from "../../../components/tickets/cardsStatusTicketComponent";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import {
  AccessTimeOutlined,
  AddCircleOutlined,
  AddOutlined,
  CheckCircleOutlineOutlined,
  CheckOutlined,
  Clear,
  ClearOutlined,
  DateRangeOutlined,
  DoDisturb,
  ErrorOutlineOutlined,
  EventRepeatOutlined,
  ManageHistoryOutlined,
  PendingOutlined,
  PersonPinCircleOutlined,
  Search,
  SupportAgentOutlined,
  SyncOutlined,
  TroubleshootOutlined,
  TurnSlightRightOutlined,
} from "@mui/icons-material";

import { useEffect, useState } from "react";
import LoaderThreeDots from "../../../components/loadingAnimation";
import apiCliente from "../../../services/apiCliente";
import ConfusedMale from "../../../components/artsPersonComponent/confusedMale";
import TicketComponentClient from "../../../components/tickets/ticketComponentClient";

import { useOutletContext } from "react-router-dom";
import ModalNotificaoAvaliacao from "../../../components/tickets/modalNotificaoAvaliacao";
import ModalAvaliacaoComponent from "../../../components/tickets/modalAvaliacaoComponent";
import dayjs from "dayjs";
import ButtonTime from "../../../components/buttonTime";
import FilterBar from "../../../components/topBarFilter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { DatePicker } from "@mui/x-date-pickers";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import OsComponent from "../../../components/tickets/ticketComponentIxc";
import OsComponentCliente from "../../../components/tickets/osComponentCliente";
import TicketComponentVero from "../../../components/tickets/ticketComponentVero";
import ModalNewTicket from "../../../components/tickets/modalNewTicket";
import ModalNewTicketCliente from "../../../components/tickets/modalNewTicketCliente";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default function Tickets(params) {
  const cliente = JSON.parse(localStorage.getItem("userCliente"));
  const configPermissao = cliente?.usuarioCliente?.cliente?.configPermissao;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviços"
      : erp === "VOALLE"
        ? "Contrato"
        : erp === "IXC"
          ? "Contrato"
          : "Serviços";
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [openNotificaoAvaliacao, setOpenNotificaoAvaliacao] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [ticketsAbertos, setTicketsAbertos] = useState([]);
  const [isValidRange, setIsValidRange] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [ticketsResolvidos, setTicketsResolvidos] = useState([]);
  const [ticketsAgdAvaliacao, setTicketsAgdAvaliacao] = useState([]);
  const [allTickets, setAllTickets] = useState({});
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(1);
  const [selectTime, setSelectTime] = useState(8);
  const [openFilter, setOpenFilter] = useState(false);
  const filter = createFilterOptions();
  const [filterData, setFilterData] = useState({
    initialDate: dayjs()
      .subtract(30, "day")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });
  const [allServicesCliente, setAllServiceCliente] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [buscarTicket, setBuscarTicket] = useState("");
  const [clientId, setClientId] = useState("");
  const [openNewTicket, setOpenNewTicket] = useState(false);
  const [userClientId, setUserClientId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const theme = useTheme();
  const styles = useStyles(theme);
  const itemsPerPage = 12;
  const configErp = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };
  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Todos",
    },
    1: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    2: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    3: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    4: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    5: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    6: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    7: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    8: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    9: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    10: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };
  // const { controllerDashboard, setControllerDashboard } = useOutletContext();
  const [countTickets, setContTickets] = useState({});
  const currentList =
    value === 0
      ? ticketsAbertos
      : value === 1
        ? ticketsAgdAvaliacao
        : value === 2
          ? ticketsResolvidos
          : value === 3
            ? tickets
            : [];
  const filteredRows = currentList?.filter((row) => {
    const search = buscarTicket?.toLowerCase()?.trim() || "";

    const matchesSearch =
      row?.usuario_responsavel?.some((u) =>
        u.name?.toLowerCase().includes(search),
      ) ||
      row?.usuario_abertura?.toLowerCase()?.includes(search) ||
      row?.protocolo?.toLowerCase()?.includes(search) ||
      row?.data_cadastro?.toLowerCase()?.includes(search) ||
      row?.descricao_abertura?.toLowerCase()?.includes(search) ||
      row?.status?.toLowerCase()?.includes(search) ||
      row?.servico?.id_cliente_servico
        ?.toString()
        ?.toLowerCase()
        ?.includes(search) ||
      row?.assunto?.toLowerCase()?.includes(search) ||
      row?.filial?.toLowerCase()?.includes(search);

    const matchesSelectedService = selectedService
      ? row?.servico?.id_cliente_servico?.toString() ===
        selectedService?.toString()
      : true;

    return matchesSearch && matchesSelectedService;
  });
  const totalPages = Math.ceil((filteredRows?.length || 0) / itemsPerPage);
  const paginatedRows = filteredRows?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage,
  );

  const { controllerDashboard, setControllerDashboard } = useOutletContext();

  useEffect(() => {
    setTickets(allTickets?.atendimentos);
    setTicketsAgdAvaliacao(allTickets?.statusSeparado?.agdAvaliacao);
    setTicketsAbertos(allTickets?.statusSeparado?.abertos);
    setTicketsResolvidos(allTickets?.statusSeparado?.resolvidos);
    let initialCount = {};

    let statusCounts = {};

    switch (erp) {
      case "HUBSOFT":
        initialCount = {
          pendente: 0,
          resolvido: 0,
          agdAnalise: 0,
        };
        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "pendente":
                acc.pendente++;
                break;

              case "resolvido":
                acc.resolvido++;
                break;
              case "aguardando_analise":
                acc.agdAnalise++;
                break;
              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );
        setContTickets({
          pendente: statusCounts?.pendente || 0,
          resolvido: statusCounts?.resolvido || 0,
          agdAnalise: statusCounts?.agdAnalise || 0,
          total:
            statusCounts?.pendente +
              statusCounts?.resolvido +
              statusCounts?.agdAnalise || 0,
        });

        break;

      case "VOALLE":
        initialCount = {
          encerramento: 0,
          andamento: 0,
          abertura: 0,
          fechamento: 0,
          cancelado: 0,
          agClassificacao: 0,
        };
        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "Encerramento":
                acc.encerramento++;
                break;
              case "Andamento":
                acc.andamento++;
                break;
              case "Abertura":
                acc.abertura++;
                break;
              case "Fechamento":
                acc.fechamento++;
                break;
              case "Cancelado":
                acc.cancelado++;
                break;
              case "Ag. Classificação":
                acc.agClassificacao++;
                break;
              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );
        setContTickets({
          encerramento: statusCounts?.encerramento || 0,
          andamento: statusCounts?.andamento || 0,
          fechamento: statusCounts?.fechamento || 0,
          cancelado: statusCounts?.cancelado || 0,
          abertura: statusCounts?.abertura || 0,
          agClassificacao: statusCounts?.agClassificacao || 0,
          total:
            statusCounts?.encerramento +
              statusCounts?.andamento +
              statusCounts?.fechamento +
              statusCounts?.cancelado +
              statusCounts?.abertura +
              statusCounts?.agClassificacao || 0,
        });

        break;

      case "IXC":
        initialCount = {
          novo: 0,
          pendente: 0,
          emProgresso: 0,
          solucionado: 0,
        };

        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "Novo":
                acc.novo++;
                break;
              case "Pendente":
                acc.pendente++;
                break;
              case "Em progresso":
                acc.emProgresso++;
                break;
              case "Solucionado":
                acc.solucionado++;
                break;

              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );
        setContTickets({
          novo: statusCounts?.novo || 0,
          pendente: statusCounts?.pendente || 0,
          emProgresso: statusCounts?.emProgresso || 0,
          solucionado: statusCounts?.solucionado || 0,
          total:
            (statusCounts?.novo || 0) +
            (statusCounts?.pendente || 0) +
            (statusCounts?.emProgresso || 0) +
            (statusCounts?.solucionado || 0),
        });
        break;
      case "VERO":
        initialCount = {
          pendente: 0,
          emAtendimento: 0,
          solucionado: 0,
        };

        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "PENDENTE":
                acc.pendente++;
                break;
              case "EM ATENDIMENTO":
                acc.emAtendimento++;
                break;
              case "SOLUCIONADO":
                acc.solucionado++;
                break;

              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );

        setContTickets({
          pendente: statusCounts?.pendente || 0,
          emAtendimento: statusCounts?.emAtendimento || 0,
          solucionado: statusCounts?.solucionado || 0,
          total:
            (statusCounts?.pendente || 0) +
            (statusCounts?.emAtendimento || 0) +
            (statusCounts?.solucionado || 0),
        });
        break;
    }
  }, [filterData, allTickets]);
  useEffect(() => {
    if (!controllerDashboard) return;
    return controllerDashboard.abort();
  }, []);

  useEffect(() => {
    setClientId(cliente?.usuarioCliente?.clienteId?.toString());
    setUserClientId(cliente?.usuarioCliente?.id);
  }, []);

  useEffect(() => {
    setPage(1);
  }, [buscarTicket, value]);

  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now),
    );
  }, [endDate, startDate]);

  useEffect(() => {
    const isAllTickets = selectTime === 0 && selectTime !== null ? true : false;

    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    switch (erp) {
      case "HUBSOFT":
        getTickets(
          cliente?.usuarioCliente?.cliente?.cnpj,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
        );
        break;
      case "VOALLE":
        getTickets(
          null,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;

      case "IXC":
        getTickets(
          null,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;
      case "VERO":
        getTickets(
          cliente?.usuarioCliente?.cliente?.cnpj,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
        );
        /*    getServicesCliente(null, selectedCliente?.clienteErpId); */
        break;
      default:
    }
  }, [filterData]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    switch (erp) {
      case "HUBSOFT":
        getServicesCliente(cliente?.usuarioCliente?.cliente?.cnpj);
        break;
      case "VOALLE":
        getServicesCliente(
          null,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;

      case "IXC":
        getServicesCliente(
          null,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;
    }

    window.addEventListener("resize", handleResize);
  }, []);
  const refrashTickets = () => {
    const isAllTickets = selectTime === 0 && selectTime !== null ? true : false;

    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    switch (erp) {
      case "HUBSOFT":
        getTickets(
          cliente?.usuarioCliente?.cliente?.cnpj,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
        );
        break;
      case "VOALLE":
        getTickets(
          null,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;

      case "IXC":
        getTickets(
          null,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
          cliente?.usuarioCliente?.cliente?.clienteErpId,
        );
        break;
      case "VERO":
        getTickets(
          cliente?.usuarioCliente?.cliente?.cnpj,
          signal,
          filterData?.initialDate,
          filterData?.finalDate,
          isAllTickets,
        );
        /*    getServicesCliente(null, selectedCliente?.clienteErpId); */
        break;
      default:
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleOpenNewTicket = () => {
    setOpenNewTicket(true);
  };
  const handleCloseNewTicket = () => {
    setOpenNewTicket(false);
  };

  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).set("minute", 59).set("hour", 23).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };

  const getTickets = async (
    cnpj,
    signal,
    initialDate,
    finalDate,
    isAllTickets,
    clienteErpId,
  ) => {
    try {
      setLoading(true);
      setPage(1);
      const response = await apiCliente.post(
        "/cliente/find/tickets",
        {
          cnpjClient: cnpj,
          clienteErpId: clienteErpId,
          initialDate: dayjs(initialDate)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .set("millisecond", 0)
            .toDate(),
          finalDate: dayjs(finalDate)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .set("millisecond", 59)
            .toDate(),
          isAllTickets: isAllTickets,
        },
        { signal },
      );

      setAllTickets(response?.data);
      setContTickets({
        pendente: response?.data?.statusCounts?.pendente || 0,
        resolvido: response?.data?.statusCounts?.resolvido || 0,
        agdAnalise: response?.data?.statusCounts?.agdAnalise || 0,
        total:
          response?.data?.statusCounts?.pendente +
            response?.data?.statusCounts?.resolvido +
            response?.data?.statusCounts?.agdAnalise || 0,
      });

      /*  setTicketsAbertos(response?.data?.statusSeparado?.abertos);
      setTicketsResolvidos(response?.data?.statusSeparado?.resolvidos);*/
      /*   setTicketsAgdAvaliacao(response?.data?.statusSeparado?.agdAvaliacao); */
      if (response?.data?.statusSeparado?.agdAvaliacao?.length > 0) {
        setOpenNotificaoAvaliacao(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const getTicketDetails = async (ticketId) => {
    try {
      const response = await apiCliente.post("/cliente/find/tickets/id", {
        ticketId: ticketId,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const getForm = async (formId) => {
    try {
      const response = await apiCliente.post("/client/find/form", {
        formId: formId,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const createAnswerForm = async (
    rating = [],
    options = [],
    comment = [],
    formId = "",
    ticketId = "",
    ticketErpId = "",
  ) => {
    try {
      if (
        localStorage.getItem("user") ||
        window.location.pathname.includes("/mirror/")
      ) {
        setSnackbar({
          children: "Somente o cliente pode enviar avaliações.",
          severity: "warning",
        });
        return;
      }
      const response = await apiCliente.post("/client/form/createAnswer", {
        rating: rating,
        options: options,
        comment: comment?.map((comt) => ({
          ...comt,
          answer: comt?.answer?.trim(),
        })),
        formId: formId,
        clientId: clientId,
        userClientId: userClientId,
        ticketId: ticketId,
        ticketErpId: ticketErpId,
      });
      setSnackbar({
        children: "Pesquisa de satisfação enviada!",
        severity: "success",
      });

      const ticketAvaliado = ticketsAgdAvaliacao?.find(
        (ticket) =>
          ticket?.id_atendimento === ticketErpId ||
          ticket?.id_atendimento === ticketId,
      );

      setAllTickets((prev) => {
        // 1. Atualiza agdAvaliacao removendo o ticketAvaliado
        const novaAgdAvaliacao = prev?.statusSeparado?.agdAvaliacao?.filter(
          (ticket) => ticket?.id_atendimento !== ticketAvaliado?.id_atendimento,
        );

        // 2. Atualiza resolvidos: adiciona o ticket avaliado e ordena
        const novoArrayResolvidos = [
          ...(prev?.statusSeparado?.resolvidos || []),
          { ...ticketAvaliado, isAvaliado: true },
        ];

        const resolvidosOrdenados = novoArrayResolvidos.sort((a, b) => {
          const [diaA, mesA, anoA] = a?.data_cadastro?.split("/")?.map(Number);
          const [diaB, mesB, anoB] = b?.data_cadastro?.split("/")?.map(Number);

          const dataA = new Date(anoA, mesA - 1, diaA);
          const dataB = new Date(anoB, mesB - 1, diaB);

          return dataB - dataA; // Mais recente primeiro
        });

        // 3. Atualiza atendimentos marcando o ticket como avaliado
        const novosAtendimentos = prev?.atendimentos?.map((ticket) => {
          if (
            ticket?.id_atendimento?.toString() ===
            ticketAvaliado?.id_atendimento?.toString()
          ) {
            return { ...ticket, isAvaliado: true };
          } else {
            return ticket;
          }
        });

        // 4. Retorna novo estado completo
        return {
          ...prev,
          statusSeparado: {
            ...prev.statusSeparado,
            agdAvaliacao: novaAgdAvaliacao,
            resolvidos: resolvidosOrdenados,
          },
          atendimentos: novosAtendimentos,
        };
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao responder pesquisa de satisfação",
        severity: "error",
      });
    } finally {
    }
  };
  const getServicesCliente = async (cnpj, clienteId) => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    try {
      const response = await apiCliente.post(
        "/cliente/find/allServiceClient",
        {
          cnpj: cnpj,
          idClienteErp: clienteId,
        },
        {
          signal,
        },
      );

      setAllServiceCliente(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(1);
  };

  const handleChangePagination = (event, newPage) => {
    setPage(newPage);
  };

  const handleCloseNotificao = () => {
    setOpenNotificaoAvaliacao(false);
  };
  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    ...(erp === "HUBSOFT" && configPermissao?.openTicket === true
      ? [
          {
            icon: <AddOutlined />,
            name: "Novo Ticket",
            onClick: () => handleOpenNewTicket(),
          },
        ]
      : []),
  ];

  return (
    <Box sx={styles.containerPageTickets}>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              "@media (max-width:1349px)": { flexDirection: "column" },
              gap: 1,
              width: "100%",
            }}
          >
            <Box sx={styles.autocompleteFilter}>
              <Autocomplete
                disabled={loading}
                value={
                  (Array.isArray(allServicesCliente) &&
                    allServicesCliente?.find(
                      (service) =>
                        service?.id_cliente_servico?.toString() ===
                        selectedService?.toString(),
                    )) ||
                  null
                }
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome}`
                    : ""
                }
                onChange={(_, newValue) => {
                  setSelectedService(newValue?.id_cliente_servico?.toString());

                  const filterDataStorage = JSON.parse(
                    localStorage.getItem("filterData"),
                  );
                  const newFilterData = {
                    ...filterDataStorage,
                    serviceId: newValue?.id_cliente_servico?.toString(),
                    interfaceId: "",
                    hostId: "",
                  };

                  localStorage.setItem(
                    "filterData",
                    JSON.stringify(newFilterData),
                  );
                }}
                clearIcon={
                  <Clear
                    onClick={() => {
                      const filterDataStorage = JSON.parse(
                        localStorage.getItem("filterData"),
                      );
                      const newFilterData = {
                        ...filterDataStorage,
                        serviceId: "",
                      };

                      localStorage.setItem(
                        "filterData",
                        JSON.stringify(newFilterData),
                      );
                      setSelectedService(null);
                    }}
                  />
                }
                size="small"
                options={
                  Array.isArray(allServicesCliente) ? allServicesCliente : []
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={labelErp}
                    size="small"
                    sx={{
                      fontSize: "0.75rem", // diminui fonte geral
                      "& .MuiInputBase-input": {
                        padding: "6px 8px", // padding interno reduzido
                        fontSize: "0.75rem", // fonte do input
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.90rem", // fonte da label
                      },
                    }}
                  />
                )}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {configErp(option?.invertInfo).labelRef}:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />
            </Box>
            <Box sx={styles.autocompleteFilter}>
              <TextField
                id="input-with-icon-textfield"
                size="small"
                label="Buscar ticket"
                variant="outlined"
                autoComplete="off"
                placeholder="Protocolo, descrição, etc..."
                sx={{
                  display: "flex",
                  flexGrow: 1,
                  fontSize: "0.90rem", // diminui fonte geral
                  "& .MuiInputBase-input": {
                    padding: "8px 10px", // padding interno reduzido
                    fontSize: "0.80rem", // fonte do input
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.90rem", // fonte da label
                  },
                }}
                value={buscarTicket}
                onChange={(event) => {
                  setBuscarTicket(event?.target?.value?.trimStart());
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: buscarTicket ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setBuscarTicket("")}
                        edge="end"
                      >
                        <Clear size={"small"} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Box>
          </Box>
        }
        selectorComponentRight={
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <ButtonTime
              open={open}
              optionsTime={optionsTime}
              selectTime={selectTime}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              loading={loading}
              handleStartChange={handleStartChange}
              handleEndChange={handleEndChange}
              handleAplicar={handleAplicar}
              isValidRange={isValidRange}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              setSelectTime={setSelectTime}
              handleSelectTime={handleSelectTime}
              filterData={filterData}
              DateTime={DatePicker}
              formatDayjs={"DD/MM/YY"}
            />
            {erp === "HUBSOFT" && configPermissao?.openTicket === true && (
              <>
                <Tooltip title="Novo Ticket">
                  <Button
                    startIcon={<AddOutlined fontSize="small" />}
                    variant="contained"
                    disabled={loading}
                    sx={{ whiteSpace: "nowrap", height: "40px" }}
                    onClick={() => handleOpenNewTicket()}
                  >
                    Novo ticket
                  </Button>
                </Tooltip>
              </>
            )}
          </Box>
        }
      />
      {erp === "HUBSOFT" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
        >
          <Grid item xs={2} sm={4} md={6} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Resolvidos"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.resolvido || 0}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Aguardando análise"
              typeCard={2}
              icon={AccessTimeOutlined}
              valueCard={countTickets?.agdAnalise}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Pendentes"
              typeCard={3}
              icon={ErrorOutlineOutlined}
              valueCard={countTickets?.pendente}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}
      {erp === "VOALLE" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 8, md: 6, lg: 6, xl: 6, xxl: 12 }}
        >
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Encerramento"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.encerramento}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Fechamento"
              typeCard={6}
              icon={CheckCircleOutlineOutlined}
              valueCard={countTickets?.fechamento || 0}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Abertura"
              typeCard={2}
              icon={AddCircleOutlined}
              valueCard={countTickets?.abertura}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Andamento"
              typeCard={3}
              icon={AccessTimeOutlined}
              valueCard={countTickets?.andamento}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Ag. Classificação"
              typeCard={7}
              icon={PendingOutlined}
              valueCard={countTickets?.agClassificacao}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Cancelado"
              typeCard={10}
              icon={DoDisturb}
              valueCard={countTickets?.cancelado}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}
      {erp === "IXC" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 4, lg: 8, xl: 8, xxl: 8 }}
        >
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Solucionado"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.solucionado}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Novo"
              typeCard={6}
              icon={AddCircleOutlined}
              valueCard={countTickets?.novo}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Pendente"
              typeCard={3}
              icon={ErrorOutlineOutlined}
              valueCard={countTickets?.pendente}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Em progresso"
              typeCard={2}
              icon={SyncOutlined}
              valueCard={countTickets?.emProgresso}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}
      {erp === "VERO" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
        >
          <Grid item xs={2} sm={4} md={6} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Solucionado"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.solucionado || 0}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Em atendimento"
              typeCard={2}
              icon={AccessTimeOutlined}
              valueCard={countTickets?.emAtendimento}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Pendentes"
              typeCard={3}
              icon={ErrorOutlineOutlined}
              valueCard={countTickets?.pendente}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}
      <Box sx={{ marginTop: "10px" }}>
        <Box sx={styles.containerTabs}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable tabs"
            allowScrollButtonsMobile
          >
            <Tab label="Abertos" />
            <Tab label="Aguardando avaliação" />
            <Tab label="Resolvidos" />
            <Tab label="Todos" />
          </Tabs>
        </Box>

        {loading ? (
          <Box sx={styles.boxLoading}>
            <LoaderThreeDots />
          </Box>
        ) : paginatedRows?.length === 0 && buscarTicket ? (
          <Box sx={styles.containerNoTickets}>
            <Box
              sx={styles.paperNoTickets}
              elevation={theme.palette.mode === "dark" ? 0 : 3}
            >
              <Box sx={styles.containerImgNoTickets}>
                <ConfusedMale
                  mainFill={theme.palette.secondary.dark}
                  primaryCircleFill={theme.palette.secondary.main}
                  highlightTitle={"Oops !"}
                  subtitle={`Parece que não\nencontramos nenhum\nticket.`}
                />
              </Box>
            </Box>
          </Box>
        ) : paginatedRows?.length === 0 ? (
          <Box sx={styles.containerNoTickets}>
            <Box
              sx={styles.paperNoTickets}
              elevation={theme.palette.mode === "dark" ? 0 : 3}
            >
              <Box sx={styles.containerImgNoTickets}>
                <ConfusedMale
                  mainFill={theme.palette.secondary.dark}
                  primaryCircleFill={theme.palette.secondary.main}
                  highlightTitle={"Oops !"}
                  subtitle={`Parece que não\nencontramos nenhum ticket\n${
                    value === 0
                      ? "em aberto."
                      : value === 1
                        ? "aguardando avaliação"
                        : value === 2
                          ? "resolvido"
                          : ""
                  }`}
                />
              </Box>
            </Box>
          </Box>
        ) : (
          <>
            <Grid
              container
              spacing={1}
              columns={{ xs: 2, sm: 4, md: 6, lg: 8, xl: 8, xxl: 12 }}
            >
              {paginatedRows?.map((ticket) => (
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={3}
                  lg={2}
                  key={ticket.id_atendimento}
                >
                  {erp === "HUBSOFT" && (
                    <TicketComponentClient
                      title={`${ticket?.cliente?.codigo_cliente} - ${ticket?.cliente?.nome || ""}`}
                      protocolo={ticket?.protocolo}
                      descricao={ticket?.descricao_abertura}
                      cliente={ticket?.cliente?.nome || ""}
                      dataCadastro={ticket?.data_cadastro}
                      usuarioAbertura={ticket?.usuario_abertura}
                      status={ticket?.status}
                      ticketId={ticket?.id_atendimento}
                      fluxoAtendimento={ticket?.fluxoAtendimento}
                      getTicketDetails={getTicketDetails}
                      isAvaliado={ticket?.isAvaliado}
                      formId={ticket?.formId}
                      getForm={getForm}
                      createAnswerForm={createAnswerForm}
                      setSnackbar={setSnackbar}
                      servicoId={ticket?.servico?.id_cliente_servico || ""}
                      labelErp={labelErp}
                      allInfoTicket={ticket}
                    />
                  )}

                  {(erp === "IXC" || erp === "VOALLE") && (
                    <OsComponentCliente
                      protocolo={ticket?.protocolo}
                      descricao={ticket?.descricao_abertura}
                      assunto={ticket?.assunto}
                      setor={ticket?.setor}
                      filial={ticket?.filial}
                      prioridade={ticket?.prioridade}
                      sla={ticket?.sla}
                      id_ticket={ticket?.id_ticket}
                      cliente={ticket?.cliente?.nome || ""}
                      dataCadastro={dayjs(ticket?.data_cadastro).format(
                        "DD/MM/YYYY",
                      )}
                      isEdit={false}
                      selectedCliente={ticket?.isClienteAdd}
                      usuarioAbertura={ticket?.usuario_abertura}
                      status={ticket?.status}
                      ticketId={ticket?.id_atendimento}
                      getTicketDetails={getTicketDetails}
                      setSnackbar={setSnackbar}
                      servicoId={ticket?.idClienteServico || ""}
                      labelErp={labelErp}
                      isAtendimento={true}
                      getForm={getForm}
                      formId={ticket?.formId}
                      isAvaliado={ticket?.isAvaliado}
                      createAnswerForm={createAnswerForm}
                    />
                  )}
                  {erp === "VERO" && (
                    <TicketComponentVero
                      ticketDetails={ticket}
                      title={`${ticket?.cliente?.codigo_cliente} - ${ticket?.cliente?.nome || ""}`}
                      protocolo={ticket?.protocolo}
                      descricao={ticket?.descricao_abertura}
                      cliente={ticket?.cliente?.nome || ""}
                      dataCadastro={ticket?.data_cadastro}
                      usuarioAbertura={ticket?.usuario_abertura}
                      status={ticket?.status}
                      ticketId={ticket?.id_atendimento}
                      fluxoAtendimento={ticket?.fluxoAtendimento}
                      getTicketDetails={getTicketDetails}
                      isEdit={false}
                      isCliente={true}
                      setSnackbar={setSnackbar}
                      servicoId={ticket?.servico?.id_cliente_servico || ""}
                      labelErp={labelErp}
                      tipoAtendimentoVoalle={ticket?.tipo_atendimento}
                      allEtapasFluxoAtendimentos={
                        allTickets?.allEtapasFluxoAtendimentos
                      }
                      historicoFluxoAtendimento={
                        ticket?.historicoFluxoAtendimento
                      }
                      assunto={ticket?.assunto}
                      allInfoTicket={ticket}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          </>
        )}
        {erp === "HUBSOFT" && (
          <ModalNewTicketCliente
            open={openNewTicket}
            handleClose={handleCloseNewTicket}
            refrashTIckets={refrashTickets}
            cliente={cliente?.usuarioCliente?.cliente}
          />
        )}
        <ModalNotificaoAvaliacao
          handleClose={handleCloseNotificao}
          setValue={setValue}
          open={openNotificaoAvaliacao}
          setOPen={setOpenNotificaoAvaliacao}
          ticketsCount={ticketsAgdAvaliacao?.length}
        />
      </Box>

      {totalPages > 1 && !loading && (
        <Box sx={{ marginTop: "auto" }} display="flex" justifyContent="center">
          <Box sx={{ marginTop: "10px" }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePagination}
              color="primary"
            />
          </Box>
        </Box>
      )}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
